import { useState } from 'react';
import { Share2, Facebook, Twitter, Linkedin, MessageCircle, Send, Link as LinkIcon, Check } from 'lucide-react';

const ShareSection = () => {
  const [copied, setCopied] = useState(false);
  const currentUrl = window.location.href;
  const pageTitle = document.title;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(pageTitle + ' ' + currentUrl)}`,
    telegram: `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(pageTitle)}`,
    instagram: '#',
    twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(pageTitle)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(currentUrl)}`,
    email: `mailto:?subject=${encodeURIComponent(pageTitle)}&body=${encodeURIComponent(currentUrl)}`,
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const shareButtons = [
    { name: 'WhatsApp', icon: 'fab fa-whatsapp', url: shareLinks.whatsapp, color: 'text-green-600' },
    { name: 'Telegram', icon: 'fab fa-telegram', url: shareLinks.telegram, color: 'text-blue-600' },
    { name: 'Instagram', icon: 'fab fa-instagram', url: shareLinks.instagram, color: 'text-pink-600' },
    { name: 'Twitter', icon: 'fab fa-twitter', url: shareLinks.twitter, color: 'text-sky-600' },
    { name: 'LinkedIn', icon: 'fab fa-linkedin', url: shareLinks.linkedin, color: 'text-blue-700' },
    { name: 'Email', icon: 'fas fa-envelope', url: shareLinks.email, color: 'text-gray-600' },
  ];

  return (
    <div className="glass rounded-xl p-4">
      <h3 className="text-base font-bold gradient-text mb-3">Share This Article</h3>
      <div className="flex flex-wrap gap-2 mb4">
        {shareButtons.map((button) => (
          <a
            key={button.name}
            href={button.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`flex items-center gap-1.5 px-3 py-2 glass rounded-lg transition-all text-xs ${button.color}`}
            title={button.name}
          >
            <i className={`${button.icon} text-base`}></i>
            <span className="hidden sm:inline">{button.name}</span>
          </a>
        ))}
        
        <div className="flex gap-2">
        <input
          type="text"
          value={currentUrl}
          readOnly
          className="flex-1 px-3 py-2 text-sm rounded-lg glass border border-border bg-background/50 text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
          aria-label="Article URL"
        />
        <button
          onClick={handleCopy}
          className={`px-3 sm:px-4 py-2 rounded-lg font-medium transition-all flex items-center gap-2 text-xs ${
            copied 
              ? 'bg-gradient-to-r from-green-500 to-emerald-500 text-white shadow-md' 
              : 'glass hover:bg-primary/10 text-foreground'
          }`}
        >
          {copied ? (
            <>
              
              <span className="text-xs font-medium">Copied!</span>
              <Check className="w-3 h-3" />
            </>
          ) : (
            <>
              
              <span className="text-xs text-gray-800 font-medium">Copy</span>
              <LinkIcon className="w-3 h-3" />
            </>
          )}
        </button>
      </div>
      </div>
    </div>
  );
};

export default ShareSection;
